/**
 * @generated SignedSource<<1361c6b8b11d40fecc6133ea5f81d5b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateTeamContactInput = {
  emailAddress?: string | null | undefined;
  id: string;
  phoneNumber?: string | null | undefined;
  teamName: string;
};
export type UpdateTeamContactDialogMutation$variables = {
  input: UpdateTeamContactInput;
};
export type UpdateTeamContactDialogMutation$data = {
  readonly updateTeamContact: {
    readonly emailAddress: string | null | undefined;
    readonly id: string;
    readonly phoneNumber: string | null | undefined;
    readonly teamName: string;
  };
};
export type UpdateTeamContactDialogMutation = {
  response: UpdateTeamContactDialogMutation$data;
  variables: UpdateTeamContactDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TeamContact",
    "kind": "LinkedField",
    "name": "updateTeamContact",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teamName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emailAddress",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "phoneNumber",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateTeamContactDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateTeamContactDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5f30688da18fd5d7d21f986a82186de6",
    "id": null,
    "metadata": {},
    "name": "UpdateTeamContactDialogMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateTeamContactDialogMutation(\n  $input: UpdateTeamContactInput!\n) {\n  updateTeamContact(input: $input) {\n    id\n    teamName\n    emailAddress\n    phoneNumber\n  }\n}\n"
  }
};
})();

(node as any).hash = "c7f8794c658a49dabbdb4febac2870d5";

export default node;
